import styled from 'styled-components'
import {
	WrapperBlock,
	themeObject,
	textModels,
	Breakpoints,
	media,
} from 'Pages/landings/newLandings/common/style'

export const Wrapper = styled(WrapperBlock)`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	color: ${themeObject.colors.grey[800]};
	${media('flex-direction: row;  align-items: center;', Breakpoints.lx)};
`
export const Contact = styled.div`
	${textModels('heading', 'h2', '600')}
	margin-bottom: 32px;
	${media('margin: 0px 32px 0px 0px;', Breakpoints.lx)};
`
export const Title = styled.p`
	${textModels('heading', 'h2', '600')}
	margin-bottom: 16px;
`
export const Instructions = styled.div`
	padding: 24px 32px;
	border-radius: 16px;
	box-shadow: 0 0 0 1px ${themeObject.colors.grey[200]};
	box-sizing: border-box;
	${media('width: 272px; padding: 24px 18px 24px 32px;', Breakpoints.lx)};
	${media('width: 384px; padding: 24px 32px;', Breakpoints.xl)};
`
export const Info = styled.p`
	${textModels('notAdaptive', 'xl', '600')}
	margin-bottom: 16px;
	${media('margin-bottom: 32px;', Breakpoints.sm)};
	${media('width: 208px;', Breakpoints.lx)};
	${media('width: auto;', Breakpoints.xl)};
`
export const Href = styled.a`
	${textModels('notAdaptive', 'm', '400')}
	text-decoration: underline;
	text-decoration-color: ${themeObject.colors.brand[500]};
	text-decoration-thickness: 1px;
	text-underline-offset: 5px;
	color: ${themeObject.colors.brand[500]};
`
